<template>
  <div class="col-lg-4 col-md-6 col-12" >
    <div class="pb-0 card-header">
      <div class="d-lg-flex">
        <i class="fa-solid fa-file-invoice-dollar icon-primary mt-2"></i><h6 class="ms-2 mb-3">{{ $t('key_shipmentSummaryInfo_shipmentSummary') }}</h6>
      </div>
    </div>
    <div class="pb-0 card-body">
      <div class="d-flex justify-content-between">
        <span class="text-sm">{{ $t('key_shipmentSummaryInfo_packagesSum') }}:</span>
        <span class="text-sm">{{ $numberFormat.toAmount(PackagesSum) }}</span>
      </div> 
      <div class="d-flex justify-content-between">
        <span class="text-sm">{{ $t('key_shipmentSummaryInfo_weightSum') }}:</span>
        <span class="text-sm">{{ $numberFormat.toAmount(WeightSum) }} {{ 'Kg.' }}</span>
      </div>
      <br />
      <Button v-if="originEntityId != null && originEntityType != null && originEntityType == 'P'" class="mt-2" color="primary" size="sm" @click="openOrigin">
        {{ $t('key_shipmentSummaryInfo_originOrder') }}
      </Button>
      <Button v-if="originEntityId != null && originEntityType != null && originEntityType == 'D'" class="mt-2" color="primary" size="sm" @click="openOrigin">
        {{ $t('key_shipmentSummaryInfo_originReturn') }}
      </Button>
    </div>
    <div class="pb-0 card-footer" />
  </div>
</template>

<script>

import Button from "./../../../picko_components/generic_components/Button.vue";

export default {
  name: "ShipmentSummary",
  components: {
    Button
  },
  props: {
    packages: {
      type: Object,
      default: null,
    },
    originEntityId: {
      type: String,
      default: null
    },
    originEntityType: {
      type: String,
      default: null
    }
  },  
  computed: {
    PackagesSum() {
      return this.packages.length;
    },
    WeightSum() {
      return Math.round(this.packages.reduce((suma,value)=>suma+parseFloat(value.weight),0)*100)/100;
    }
  },
  methods: {
    openOrigin() {
      let path = null

      if (this.originEntityType == "P") {
        path = "/Operations/Orders/OrderDetail/"
      } else {
        path = "/Operations/Ordersback/OrderbackDetail/"
      }

      this.$router.push({ path: `${path}${this.originEntityId}`});
    }
  }
};

</script>